<!-- SMT合同、协议 -->
<template>
  <div class="submit-protocol">
    <el-checkbox v-model="val" @change="handleEmit" class="submit-protocol__checkbox">
      我已阅读并同意
      <template v-if="isDevelopOrder">
        <BaseLink @click="downloadDevelopSmtProtocol">《研发型订单SMT贴片用户协议》</BaseLink>
        和
        <BaseLink @click="downloadDevelopPcbaProtocol">《PCBA 研发型订单合作框架协议》</BaseLink>
      </template>
      <template v-else>
        <BaseLink @click.prevent="$refs.smtProtocolDialogRef.open()">《华秋SMT贴片用户协议》</BaseLink>
        和
        <BaseLink @click="showPdf">
          《PCBA销售合作协议》
        </BaseLink>
      </template>
    </el-checkbox>
    <!-- 《华秋SMT贴片用户协议》弹框 -->
    <SmtProtocolDialog ref="smtProtocolDialogRef" />
     <!-- PDF预览组件 -->
    <pdf-preview-dialog
      :visible.sync="pdfVisible"
      :pdf-url="currentPdfUrl"
      :file-name="currentFileName"
      @download-start="handleDownloadStart"
      @download-success="handleDownloadSuccess"
      @download-error="handleDownloadError"
    />
  </div>
</template>

<script>
import SmtProtocolDialog from './smtProtocolDialog'
import PdfPreviewDialog from './PdfPreviewDialog.vue'
import CONFIG from '@@/config'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    pcbaPdfName: {
      type: String,
      default: 'Xxx'
    },
    // 订单类型：0-标准型 1-研发型
    is_develop_order: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    PdfPreviewDialog,
    SmtProtocolDialog
  },
  data() {
    return {
      pdfVisible: false,
      currentPdfUrl: '',
      currentFileName: 'document.pdf',
      val: false
    }
  },
  computed: {
    // 是否为研发型订单
    isDevelopOrder() {
      return Number(this.is_develop_order) === 1
    }
  },
  methods: {
      // PDF下载开始事件
    handleDownloadStart(url) {
      console.log('开始下载PDF:', url)
    },
    
    // PDF下载成功事件
    handleDownloadSuccess(data) {
      console.log('PDF下载成功:', data)
      this.$message.success(`文件 ${data.fileName} 下载成功！`)
    },
      // PDF下载失败事件
    handleDownloadError(error) {
      console.error('PDF下载失败:', error)
      this.$message.error(`PDF下载失败: ${error.error}`)
    },
    showPdf() {
      this.currentPdfUrl = `${CONFIG.SMTSERVICE_HOST}/online/exportPcbaContract?party_aname=${this.pcbaPdfName || ''}`
      this.currentFileName = '《PCBA销售合作协议》.pdf'
      this.pdfVisible = true
    },
    handleEmit() {
      this.$emit('input', this.val)
    },
    // 《PCBA销售合作协议》 下载
    handleDownloadPCBAPDF() {
      window.open(`${CONFIG.SMTSERVICE_HOST}/online/exportPcbaContract?party_aname=${this.pcbaPdfName || ''}`, '_self')
    },
    // 下载研发型订单SMT贴片用户协议
    downloadDevelopSmtProtocol() {
      const link = document.createElement('a')
      link.href = `${CONFIG.SMTSERVICE_HOST}/quote/研发型订单SMT贴片用户协议.pdf`
      link.download = '研发型订单SMT贴片用户协议.pdf'
      link.click()
    },
    // 下载PCBA研发型订单合作框架协议
    downloadDevelopPcbaProtocol() {
      const link = document.createElement('a')
      link.href = `${CONFIG.SMTSERVICE_HOST}/quote/PCBA 研发型订单合作框架协议.pdf`
      link.download = 'PCBA 研发型订单合作框架协议.pdf'
      link.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-protocol {
  margin-top: 8px;
  .submit-protocol__checkbox ::v-deep {
    .el-checkbox__input.is-focus .el-checkbox__inner,
    .el-checkbox__inner:hover {
      border-color: $--color-primary;
    }
    .el-checkbox__input.is-checked {
      .el-checkbox__inner {
        border-color: $--color-primary;
        background-color: $--color-primary;
      }
      & + .el-checkbox__label {
        color: inherit;
      }
    }
  }
}
</style>